<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Bloquear Atendimentos de Procedimento</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label for="">Atendimentos distribuidos</label>
								<input
									type="text"
									class="form-control"
									:disabled="true"
									:value="dados.quantidade_primeira_original"
								>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group disable">
								<label for="">Atendimentos disponíveis</label>
								<input
									type="text"
									class="form-control"
									:disabled="true"
									:value="dados.quantidade_primeira_alterada"
								>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<label for="">Atendimentos bloqueados</label>
								<input
									type="number"
									min="0"
									class="form-control"
									v-model.number="dados.quantidade_primeira_bloqueada"
								>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label for="">Retornos distribuidos</label>
								<input
									type="text"
									class="form-control"
									:disabled="true"
									:value="dados.quantidade_retorno_original"
								>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group disable">
								<label for="">Retornos disponíveis</label>
								<input
									type="text"
									class="form-control"
									:disabled="true"
									:value="dados.quantidade_retorno_alterada"
								>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<label for="">Retornos bloqueados</label>
								<input
									type="number"
									min="0"
									class="form-control"
									v-model.number="dados.quantidade_retorno_bloqueada"
								>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label for="">Locais distribuidos</label>
								<input
									type="text"
									class="form-control"
									:disabled="true"
									:value="dados.quantidade_local_original"
								>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group disable">
								<label for="">Locais disponíveis</label>
								<input
									type="text"
									class="form-control"
									:disabled="true"
									:value="dados.quantidade_local_alterada"
								>
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group">
								<label for="">Locais bloqueados</label>
								<input
									type="number"
									min="0"
									class="form-control"
									v-model.number="dados.quantidade_local_bloqueada"
								>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button
								@click="salvar()"
								class="btn btn-primary pull-right"
								type="button"
							><i class="fa fa-save"></i> Salvar</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i class="fa fa-close"></i> Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
	filters: { },
	computed: { },
	props: ["show", "id"],
	data: () => ({
        filtros: { },
        bloqueados: {
            primeira: 0,
            retorno: 0,
            local: 0,
        },
		dados: {
            quantidade_primeira: 0,
			quantidade_primeira_original: 0,
			quantidade_primeira_alterada: 0,
			quantidade_primeira_bloqueada: "",
            quantidade_retorno: 0,
            quantidade_retorno_original: 0,
            quantidade_retorno_alterada: 0,
            quantidade_retorno_bloqueada: "",
            quantidade_local: 0,
            quantidade_local_original: 0,
            quantidade_local_alterada: 0,
            quantidade_local_bloqueada: "",
        },
	}),
	mounted() {
		document.body.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.$emit('close');
			}
		})
	},
	methods: {
		getData(id) {
			this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			axios.get(
				`${this.$store.state.serverURI}/api/distribuicao/agenda/getDistribuicaoContratoProcedimentoAtendimentosById/${id}`,
				config
			).then(response => {
                this.dados = response.data;
                this.bloqueados.primeira = this.dados.quantidade_primeira_bloqueada ? this.dados.quantidade_primeira_bloqueada : 0;
                this.dados.quantidade_primeira_alterada = this.dados.quantidade_primeira;
                this.bloqueados.retorno = this.dados.quantidade_retorno_bloqueada ? this.dados.quantidade_retorno_bloqueada : 0;
                this.dados.quantidade_retorno_alterada = this.dados.quantidade_retorno;
                this.bloqueados.local = this.dados.quantidade_local_bloqueada ? this.dados.quantidade_local_bloqueada : 0;
                this.dados.quantidade_local_alterada = this.dados.quantidade_local;
				this.$store.commit("TOGGLE_LOADING");
			}).catch(error => {
				this.$store.commit("throwException", error);
            });

		},
        salvar() {
            console.log("teste");
            this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			axios.post(
				`${this.$store.state.serverURI}/api/distribuicao/agenda/bloquearAtendimento/${this.dados.id}`,
				this.dados,
				config
			).then(response => {
                this.$emit('atualizar');
                this.$emit('close');
				this.$store.commit("TOGGLE_LOADING");
			}).catch(error => {
				this.$store.commit("throwException", error);
            });
        }
	},
	watch: {
		'show': function (value, oldValue) {
			if (value) {
				this.getData(this.id);
			}
		},
        'dados.quantidade_primeira_bloqueada': function (value, oldValue) {
			if (!value) {
				value = 0
			}
			let qtd = parseInt(this.dados.quantidade_primeira) + parseInt(this.bloqueados.primeira)
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_primeira_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_primeira_bloqueada = qtd;
			}
		},
        'dados.quantidade_retorno_bloqueada': function (value, oldValue) {
            if (!value) {
                value = 0
			}
			let qtd = parseInt(this.dados.quantidade_retorno) + parseInt(this.bloqueados.retorno)
            if (qtd >= parseInt(value)) {
                this.dados.quantidade_retorno_alterada = qtd - parseInt(value);
            } else {
                this.dados.quantidade_retorno_bloqueada = qtd;
            }
		},
        'dados.quantidade_local_bloqueada': function (value, oldValue) {
            if (!value) {
                value = 0
			}
			let qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local)
            if (qtd >= parseInt(value)) {
                this.dados.quantidade_local_alterada = qtd - parseInt(value);
            } else {
                this.dados.quantidade_local_bloqueada = qtd;
            }
		},
    },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// bloquearModal.vue?102bb505